import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { validate } from './profile-utils';
import ProfileFieldBase from './ProfileFieldBase';

class ProfileTextField extends Component {
  static propTypes = {
    action: PropTypes.func,
    editable: PropTypes.bool,
    fieldData: PropTypes.string,
  }
   
  render = () => {
    return <ProfileFieldBase
      inputTag={'input'}
      inputTagAttributes={{type: 'text'}}
      validateMethod={validate}
      {...this.props}
    />;
  };
}

export default ProfileTextField;



// WEBPACK FOOTER //
// ./src/subscription/profile/components/ProfileTextField.js